module.exports = __webpack_public_path__ + "img/4.f45637f7.jpg";